<template>
    <div class="field mb-4" v-if="isShow">
        <table class="table is-fullwidth is-countable is-borderless">
            <thead>
            <tr>
                <th class="is-narrow"></th>
                <th class="is-narrow" style="min-width: 400px">
                    ความร่วมมือกับเครือข่าย <span class="is-bold is-underlined">{{ network.title }}</span>
                    มศว
                </th>
                <th>ลักษณะความร่วมมือ</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(detail, index) in this.project.network_internals"
                :key="index"
            >
                <td class="is-counter">
                    <input type="hidden"
                           :name="'networkInternals[' + index + '][id]'"
                           v-model="detail.id"
                    />
                    <input type="hidden"
                           :name="'networkInternals[' + index + '][dept_cd]'"
                           v-model="detail.dept_cd"
                    />
                    <input type="hidden"
                           :name="'networkInternals[' + index + '][parameter_id]'"
                           v-model="detail.parameter_id"
                    />
                </td>
                <td>
                    <v-select class="is-fullwidth"
                              :options="departments"
                              :value="getDepartment(detail)"
                              @input="(value) => detail.dept_cd = value.value"
                    >
                        <p slot="no-options">ไม่พบชื่อหน่วยงานตามที่ระบุ</p>
                    </v-select>

                </td>
                <td>
                    <textarea class="textarea"
                              :name="'networkInternals[' + index + '][description]'"
                              v-model="detail.description"
                              rows="1"
                              v-autosize
                    ></textarea>
                </td>
                <td class="is-narrow">
                    <span class="delete" @click.prevent="deleteNetwork(index)"></span>
                </td>
            </tr>
            </tbody>
        </table>
        <button type="button" class="button is-300"
                @click.prevent="addNetwork"
        >
                <span class="icon">
                    <i class="fa fa-plus"></i>
                </span>
            เพิ่มความร่วมมือ
            เครือข่าย&nbsp;<span class="is-bold is-underlined">{{ network.title }}</span>
        </button>
    </div>
</template>
<script type="text/babel">
    export default {

        data() {
            return {
                departments
            }
        },
        props: {
            project: {type: Object, required: true},
            network: {type: Object, required: true}
        },
        computed: {
            isShow() {
                return this.network !== undefined && this.network.active;
            },
        },
        watch: {
            isShow() {
                if (this.isShow && this.project.network_internals.length === 0) {
                    this.addNetwork();
                }
            }
        },
        methods: {
            addNetwork() {
                this.project.network_internals.push({
                    id: null,
                    title: null,
                    dept_cd: null,
                    description: null,
                    parameter_id: this.network.parameter_id,
                    type: this.network.child_type,
                })
            },
            deleteNetwork(index) {
                this.project.network_internals.splice(index, 1);
            },
            getDepartment(detail) {
                return detail.dept_cd != null ?
                    _.find(this.departments, (department) => department.value == detail.dept_cd) :
                    null;
            }
        }
    }
</script>